import React, { useState } from 'react';

import { useConfiguration } from '../../../context/configurationContext';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { applyLocationToSearchHistory } from '../SearchPage.shared';
import {
  storeSearchServiceAddressDraft,
  isCompleteServiceAddressDraft,
} from '../../../util/searchServiceAddressDraft';

import { Heading, LocationAutocompleteInput } from '../../../components';

import css from './SearchLocationGatePanel.module.css';

/**
 * Inline address picker shown in the listings area when search URL lacks location params.
 */
const SearchLocationGatePanel = props => {
  const { history, location } = props;
  const intl = useIntl();
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();

  const [inputValue, setInputValue] = useState({
    search: '',
    predictions: [],
    selectedPlace: null,
  });

  const handleLocationChange = value => {
    setInputValue(value);
    if (!value?.selectedPlace) {
      return;
    }
    if (!isCompleteServiceAddressDraft(value, config)) {
      return;
    }
    storeSearchServiceAddressDraft(value, config);
    applyLocationToSearchHistory({
      history,
      location,
      routeConfiguration,
      config,
      autocompleteValue: value,
      replace: false,
    });
  };

  return (
    <section className={css.root} aria-labelledby="SearchLocationGatePanel-title">
      <div className={css.panel}>
        <Heading as="h2" rootClassName={css.title} id="SearchLocationGatePanel-title">
          <FormattedMessage id="SearchPage.locationGateTitle" />
        </Heading>
        <p className={css.description}>
          <FormattedMessage id="SearchPage.locationGateDescription" />
        </p>
        <LocationAutocompleteInput
          className={css.autocomplete}
          placeholder={intl.formatMessage({ id: 'LocationFilter.searchPlaceholder' })}
          closeOnBlur={false}
          useDarkText
          config={config}
          input={{
            value: inputValue,
            onChange: handleLocationChange,
            onFocus: () => {},
            onBlur: () => {},
          }}
        />
      </div>
    </section>
  );
};

export default SearchLocationGatePanel;
